// library imports
import { useState, useEffect } from "react";
// hook imports
import useFetch from "../hooks/useFetch";

const SITE_SELECTED_KEY = "reveai-site-selected";

export default function useSiteSelection() {
  const [fetchWrapper] = useFetch();

  const [getSiteSelectionLoading, setGetSiteSelectionLoading] = useState(false);

  const [siteList, setSiteList] = useState([]);
  const [siteSelected, setSiteSelected] = useState(null);

  function setSiteSelectedWithPersist(value) {
    localStorage.setItem(SITE_SELECTED_KEY, value);
    setSiteSelected(value);
  }

  /* API to get site selection */
  function getSiteSelection() {
    setGetSiteSelectionLoading(true);
    fetchWrapper({
      endpoint_url: "layout/getSiteSelection",
      method: "GET",
      set_content_type_header: false,
      onSuccess: (response) => {
        setGetSiteSelectionLoading(false);
        const list = response.data.site_list;
        setSiteList(list);
        if (list.length > 0) {
          const stored = localStorage.getItem(SITE_SELECTED_KEY);
          const storedValue = stored ? parseInt(stored, 10) : null;
          const isValid = list.some((s) => s.value === storedValue);
          setSiteSelected(isValid ? storedValue : list[0].value);
        }
      },
    });
  }

  useEffect(() => {
    getSiteSelection();
  }, []);

  return [siteSelected, setSiteSelectedWithPersist, siteList, getSiteSelectionLoading];
}
